export default function mitoLog({ tag, level = "error", message, error }) {
  window._MITO_ &&
    typeof window._MITO_.log === "function" &&
    window._MITO_.log({
      tag,
      level,
      message: message,
      ex: error,
    });
}
function mitoIsExist() {
  if (
    !window._MITO_ ||
    !window._MITO_.transport ||
    !window._MITO_.login ||
    !window.__MITO__.logger ||
    !window._MITO_.transport.setBizInfo
  ) {
    return false
  }
  return true
}

export function setMitoUserId(userId) {
  // console.log("[setMitoUserId] userId: ", userId);
  if (!mitoIsExist()) {
    console.warn('[mitojs]MITOJS init eror...')
    return
  }
  if (window._MITO_.transport.userId !== userId) {
    window._MITO_.login(`${userId}`)
  }
}

export function setBizInfo(data) {
  if (!mitoIsExist()) {
    console.warn('[mitojs]MITOJS init eror...')
    return
  }
  window._MITO_.transport.setBizInfo(data)
}
